// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-2dc754b5]{border-collapse:collapse;font-family:\"Trebuchet MS\",Arial,Helvetica,sans-serif;width:100%}table td[data-v-2dc754b5],table th[data-v-2dc754b5]{border:1px solid #ddd;padding:8px}table tr[data-v-2dc754b5]:nth-child(2n){background-color:#f2f2f2}table tr[data-v-2dc754b5]:hover{background-color:#ddd}table th[data-v-2dc754b5]{background-color:#92d051;color:#000!important;padding-bottom:12px;padding-top:12px;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
